module.exports = __webpack_public_path__ + "img/state-tas.66ced9f5.png";